import {inject, Injectable} from '@angular/core';
import {ChatService} from "../../../../../../services/chat.service";
import {GroupContentItem} from "../../../../../../../../chat-sdk/src/entities/groups/groupContentItem";
import {Pagination} from "../../../../../../entities/pagination.entity";

@Injectable({
  providedIn: 'root'
})
export class ChatInfoContentDocService {
  chatService = inject(ChatService);
  groupId = '';
  constructor() {
  }

  getItems(
    page: number = 1,
    filters: any,
    callback: (items: GroupContentItem[], pagination: Pagination) => void
  ) {
    this.chatService.chat.groups.getById(this.groupId).getGroupContent(page, 'documents').then(res => {
      if (res) {
        callback(res.items, res.pagination);
      }
    });
  }
}
